import { render, staticRenderFns } from "./CallGifts.vue?vue&type=template&id=7e37bd78"
import script from "./CallGifts.vue?vue&type=script&lang=js"
export * from "./CallGifts.vue?vue&type=script&lang=js"
import style0 from "./CallGifts.vue?vue&type=style&index=0&id=7e37bd78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports